<template>
  <div class="sm:col-span-6">
    <label
      v-if="label"
      :for="id"
      class="block text-sm font-medium text-left pb-1"
      >{{ labelText }}</label
    >
    <div class="mt-1 sm:col-span-2 sm:mt-0 relative">
      <input
        :id="id"
        :name="id"
        :type="type"
        :value="modelValue"
        :min="min"
        :step="step"
        :maxlength="maxLength"
        class="input-primary w-full mb-2"
        :required="required"
        :class="[
          error || errorBorder
            ? 'pr-10 !placeholder-red-300 !border-red-500 focus:outline-none ring-red-500'
            : 'shadow-sm focus:border-bkk-100 focus:ring-bkk-100 sm:text-sm',
        ]"
        :placeholder="placeholder"
        @input="validate"
        @change="validate"
        @keydown.delete="validate"
      />
      <div
        v-if="(errorMessage && error) || errorBorder"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-5 pb-2"
      >
        <ExclamationCircleIcon
          class="h-5 w-5 text-red-500"
          aria-hidden="true"
        />
      </div>
    </div>
    <div v-if="maxLength && showInputLength" class="text-right">
      {{ inputLength }}/{{ maxLength }}
    </div>
    <p v-if="errorMessage && error" class="mt-2 text-sm text-action-red">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
  name: "InputElement",
  components: {
    ExclamationCircleIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    maxLength: {
      type: String,
      default: "255",
    },
    min: {
      type: String,
      default: undefined,
    },
    step: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "",
    },
    validation: {
      type: Function,
      default: () => {
        return true;
      },
    },
    errorMessage: {
      type: String,
      default: "",
    },
    errorKey: {
      type: String,
      default: "",
    },
    errorBorder: {
      type: Boolean,
      default: false,
    },
    showInputLength: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "update-field", "validation-state"],
  data() {
    return {
      error: this.errorBorder,
    };
  },
  computed: {
    labelText() {
      return `${this.label} ${this.required ? "*" : ""}`;
    },
    inputLength() {
      return this.modelValue ? this.modelValue.length : 0;
    },
  },
  methods: {
    validate(event) {
      this.error = !this.validation(event.target.value);
      this.$emit("update:modelValue", event.target.value);
      this.$emit("update-field", event.target.value);
      this.$emit("validation-state", {
        value: event.target.value,
        error: this.error,
      });
    },
  },
};
</script>
